import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import MeetingPlacardPageProps from './meetingPlacardPageProps';
import Modal from '../containers/modal';
import Button from '../buttons/button';
import ButtonColors from '../buttons/buttonColors';
import Field from '../fields/field';
import Alert from '../alerts/alert';
import QRCode from 'react-qr-code';

class MeetingPlacardPage extends ObservingComponent<MeetingPlacardPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider);
    }

    public render({ page }: MeetingPlacardPageProps): JSX.Element {
        return (
            <div class="display-page-wrapper">
                <Alert
                    className="mb-0"
                    alert={page.alert} />

                {page.settingsVisible &&
                    <Modal
                        heading="Meeting Room Placard Settings"
                        close={() => {}}
                        hideBackButton={true}
                        footerRightButtons={[
                            <Button
                                color={ButtonColors.Primary}
                                button={page.submitButton} />
                        ]}>

                        <div class="form-container">
                            <p>
                                <b>Note: </b> Only finalized meetings will be displayed. Refresh the page to access these settings again.
                            </p>

                            <hr />

                            <Field 
                                className="inline-label"
                                field={page.form.fields[0]} />

                            <h4 class="section-header">Display Options</h4>

                            <div class="flex">
                                <div class="fill mr-1">
                                    <Field
                                        field={page.form.fields[1]} />

                                    <Field
                                        field={page.form.fields[2]} />

                                    <Field
                                        field={page.form.fields[3]} />
                                </div>

                                <div class="fill ml-1">
                                    <Field
                                        field={page.form.fields[4]} />

                                    <Field
                                        field={page.form.fields[5]} />
                                </div>
                            </div>
                        
                            <h4 class="section-header">QR Code</h4>

                            <p class="text-sm">Use the QR code below to load on other devices. </p>

                            <div class="flex mt-1">
                                <div class="ml-auto mr-auto bg-white">
                                    <QRCode value={window.location.href} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                }

                {!page.settingsVisible &&
                    <div class="meeting-placard">

                        {page.form.model.displayVenueName &&
                            <div class="venue-name">
                                <span>{page.venueName}</span>
                                <hr/>
                            </div>
                        }

                        <div class="meeting-data">
                            {(!page.meetingPlacardData || !page.meetingPlacardData.number) &&
                                <span>Available</span>
                            }

                            {page.meetingPlacardData && !!page.meetingPlacardData.number &&
                                <div>
                                    {page.form.model.displayMeetingNumber &&
                                        <div class="meeting-number">#{page.meetingPlacardData.number}</div>
                                    }

                                    {page.form.model.displayStartEndTime &&
                                        <div class="meeting-time">
                                            {page.meetingPlacardData.startTimeString}

                                            <span> - </span>

                                            {page.meetingPlacardData.endTimeString}
                                        </div>
                                    }

                                    {page.form.model.displayMeetingName &&
                                        <div class="meeting-name">{page.meetingPlacardData.name}</div>
                                    }
                                </div>
                            }
                        </div>


                        {page.form.model.displayNextMeetingStartTime &&
                            <div class="next-meeting-info">
                                <hr/>
                                Next Meeting Start:

                                {(!page.meetingPlacardData || !page.meetingPlacardData.nextMeetingStartTimeString) &&
                                    <span> Unknown</span>
                                }

                                {page.meetingPlacardData && page.meetingPlacardData.nextMeetingStartTimeString &&
                                    <span>
                                        &nbsp;

                                        {page.meetingPlacardData.nextMeetingStartTimeString}
                                    </span>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default MeetingPlacardPage;
